import axios from "axios";

// export let baseUrl = "https://g85x8vg6-8001.inc1.devtunnels.ms/api";
export let baseUrl = "https://mitch-24a0e92fe9e6.herokuapp.com/api";

// export let baseUrl = "http://192.168.100.158:8001/api";

const api = async (path, params, method) => {
  let options;
  options = {
    headers: {
      "Content-Type": "application/json",
    },
    method: method,
    ...(params && { data: JSON.stringify(params) }),
  };
  return axios(baseUrl + path, options)
    .then((response) => {
      return response;
    })
    .catch(async (error) => {
      return error.response;
    });
};

export default api;
